import {
  FormControl,
  InputBase,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
  Typography,
  styled,
} from '@mui/material'
import { Control, Controller } from 'react-hook-form'

const CustomInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 5,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 14,
    fontWeight: 'bold',
    padding: '5px 15px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
  },
}))

type SelectItem = {
  value: string
  label: string
}

type FormSelectProps = {
  name: string
  label: string
  control: Control<any>
  items: SelectItem[]
  bold?: boolean
} & SelectProps

const FormSelect = (props: FormSelectProps) => {
  const { name, label, control, items, bold } = props

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl variant="standard" fullWidth>
          {label && (
            <InputLabel htmlFor={name} shrink>
              <Typography
                color="black"
                variant="h3"
                fontWeight={700}
                fontSize={{
                  md: '18px !important',
                  xs: '16px !important',
                }}
              >
                {label}
              </Typography>
            </InputLabel>
          )}
          <Select input={<CustomInput {...field} />} aria-label={label}>
            {items.map((item, index) => (
              <MenuItem key={index} value={item.value}>
                <Typography
                  variant="body1"
                  component="span"
                  sx={{
                    fontSize: {
                      md: '14px !important',
                      xs: '12px !important',
                    },
                    mb: '0 !important',
                    ...(bold ? { fontWeight: 'bold' } : {}),
                  }}
                >
                  {item.label}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  )
}

export default FormSelect
